// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__qiYxk","rotation":"loading_rotation__3ByQR"};